import { EstadoEquipo } from "./EstadoEquipo";

export class EquipoFijo {
    id: string;
    nombre: string;
    ultimoEstado: EstadoEquipo;
}